import { Button } from "@mui/material";
import React, { useState } from "react";

const JsonViewer = ({ src, collapsed = true }) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  const toggleCollapse = (e) => {
    e.preventDefault();
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div>
      <Button variant="contained" onClick={toggleCollapse}>
        {isCollapsed ? "Expand" : "Collapse"}
      </Button>
      {!isCollapsed && <pre>{JSON.stringify(src, null, 2)}</pre>}
    </div>
  );
};

export default JsonViewer;
